/**
 * @typedef {(ACTIVATE | IDLE | SELECT | START)} TypeAction An action.
 */

/**
 * The 'ACTIVATE' action.
 * @type {'ACTION_ACTIVATE'}
 * @constant
 */
const ACTIVATE = 'ACTION_ACTIVATE';

/**
 * The 'IDLE' action.
 * @type {'ACTION_IDLE'}
 * @constant
 */
const IDLE = 'ACTION_IDLE';

/**
 * The 'SELECT' action.
 * @type {'ACTION_SELECT'}
 * @constant
 */
const SELECT = 'ACTION_SELECT';

/**
 * The 'START' action.
 * @type {'ACTION_START'}
 * @constant
 */
const START = 'ACTION_START';

export {

    ACTIVATE,
    IDLE,
    SELECT,
    START
};
